import React from 'react';

export const numberToCurrencyTemplate = (value: number) => {
    const isNegative = value < 0;
    const valueString = Math.abs(value).toFixed(2);
    const [integers, cents] = valueString.split('.');
     const integerString = integers.split('').reverse().reduce((p,c, index) => {
        const baseOneIndex = index + 1;
        p.push(c);
        if(!(baseOneIndex % 3) && baseOneIndex < (integers.split('').length)){
            p.push(`,`);
        }
        return p;
    }, []).reverse().join('');
    return (<span><span className='integer'>{`${isNegative ? '-':''}${integerString}`}</span><span className='cents'>.{cents}</span></span>);
};